module.exports = __webpack_public_path__ + "img/03.79e91b98.png";